import { injectLoginAsCheck } from '@ti/core/common/contracts'

import { isMcpLoginAsRefused } from '../bootstrap/mcp-interaction-capture'

/**
 * Whether this tab is in Login as, or arrived with a Login as handle in the landing URL. Connecting
 * an app grants the signed-in account's own access, never an impersonated one, and the API
 * requests of this flow deliberately do not carry the login-as header, so the server could not
 * tell: this check is the control. The bootstrap never lets such a tab resolve a Login as session,
 * so the handle in the URL is refused here instead of being followed.
 */
export function injectMcpLoginAsCheck(): () => boolean {
  const isLoginAsActive = injectLoginAsCheck()
  return () => isLoginAsActive() || isMcpLoginAsRefused
}
